import { render, staticRenderFns } from "./UserFreeDays.vue?vue&type=template&id=20fc7919&"
import script from "./UserFreeDays.vue?vue&type=script&lang=js&"
export * from "./UserFreeDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports